import GenericListModule from "../generic-list-module";

const debug = false
// const debug = "SearchManager"

export default class SearchManager {

    public module       : GenericListModule
    private _value      : string | null

    constructor(module:GenericListModule, currentValue:string|null=null) {
        this.module = module
        this._value = currentValue
    }

    set value(searchValue:string|null) {
        this._value = !_.isNil(searchValue) ? searchValue.toLowerCase() : null
        this.module.data.process()
        this.module.reRender()
    }

    get value() {
        return this._value
    }
}